import React from 'react';
import Icon from '../../../components/AppIcon';

const OverallSummaryCard = ({ 
  totalLoggedDays, 
  overallCompletionRate, 
  programStartDate,
  currentDay,
  totalPossibleDays = 42
}) => {
  const formatDate = (date) => {
    return new Date(date)?.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const daysSinceStart = Math.floor((new Date() - new Date(programStartDate)) / (1000 * 60 * 60 * 24)) + 1;

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-gentle">
      <div className="flex items-center space-x-3 mb-4">
        <div className="p-3 bg-primary/10 rounded-lg">
          <Icon name="TrendingUp" size={24} className="text-primary" />
        </div>
        <div>
          <h2 className="text-xl font-heading font-bold text-foreground">
            Progress Overview
          </h2>
          <p className="text-sm text-muted-foreground">
            Your CORE4 journey statistics
          </p>
        </div>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Total Logged Days */}
        <div className="text-center">
          <div className="text-2xl font-heading font-bold text-foreground mb-1">
            {totalLoggedDays}
          </div>
          <div className="text-xs text-muted-foreground">
            Days Logged
          </div>
        </div>

        {/* Overall Completion */}
        <div className="text-center">
          <div className="text-2xl font-heading font-bold text-success mb-1">
            {overallCompletionRate?.toFixed(1)}%
          </div>
          <div className="text-xs text-muted-foreground">
            Completion Rate
          </div>
        </div>

        {/* Current Day */}
        <div className="text-center">
          <div className="text-2xl font-heading font-bold text-primary mb-1">
            {currentDay}
          </div>
          <div className="text-xs text-muted-foreground">
            Current Day
          </div>
        </div>

        {/* Days Since Start */}
        <div className="text-center">
          <div className="text-2xl font-heading font-bold text-accent mb-1">
            {daysSinceStart}
          </div>
          <div className="text-xs text-muted-foreground">
            Days Active
          </div>
        </div>
      </div>
      {/* Program Timeline */}
      <div className="mt-6 pt-4 border-t border-border">
        <div className="flex items-center justify-between text-sm">
          <div className="flex items-center space-x-2">
            <Icon name="Calendar" size={16} className="text-muted-foreground" />
            <span className="text-muted-foreground">
              Started: {formatDate(programStartDate)}
            </span>
          </div>
          <div className="text-muted-foreground">
            Day {currentDay} of {totalPossibleDays}
          </div>
        </div>
        
        {/* Progress Bar */}
        <div className="mt-3 bg-muted rounded-full h-2">
          <div 
            className="bg-primary h-2 rounded-full transition-all duration-300"
            style={{ width: `${Math.min((currentDay / totalPossibleDays) * 100, 100)}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default OverallSummaryCard;